import Action from '../Action';

import style from './styles.module.css';

interface ButtonProps {
    label: string;
    active?: boolean;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    disabled?: boolean;
    className?: string;
    theme?: 'PRIMARY' | 'SECONDARY';
    size?: 'SMALL' | 'MEDIUM' | 'LARGE';
    action?: string | (() => void);
    fullWidth?: boolean;
    [key: string]: any;
}

export const Button = ({
    label = '',
    active = false,
    Icon = undefined,
    disabled = false,
    className = '',
    theme = 'PRIMARY',
    size = 'MEDIUM',
    action = undefined,
    fullWidth = false,
    ...rest
}: ButtonProps) => {
    const parsedLabel = `${label}`.trim();

    return (
        <Action
            className={`
            ${style.button} 
            ${active ? style.active : ''} 
            ${style[theme.toLowerCase()]} 
            ${style[size.toLowerCase()]} 
            ${disabled ? style.disabled : ''} 
            ${parsedLabel ? style.withText : style.noText} 
            ${fullWidth ? style.fullWidth : ''}
            ${className}
            `}
            action={disabled ? undefined : action}
            {...rest}
        >
            {Icon && <Icon className={style.icon} />}
            <span className={style.text}>{parsedLabel}</span>
        </Action>
    );
};

export default Button;
